import { cn } from '@/lib/utils'
import { HelpCircleIcon } from 'lucide-react'
import React from 'react'
import { match } from 'ts-pattern'
import ButtonBase from './Button/ButtonBase'
import {
    Popover,
    PopoverAnchor,
    PopoverContent,
    PopoverTrigger,
} from './ui/popover'

interface IProps {
    children?: React.ReactNode
    size?: 'small' | 'medium' | 'large'
    Icon?: React.ReactElement
    /** className passado para o popover trigger */
    className?: string
    borderless?: boolean
    forceEnabled?: boolean
}

export default function IconeAjuda({
    children,
    size,
    Icon,
    className,
    borderless,
    forceEnabled = false,
}: IProps) {
    const sizeClass = match(size)
        .with('small', () => '[&_svg]:size-4 p-1.5')
        .with('large', () => '[&_svg]:size-8 p-3')
        .otherwise(() => '[&_svg]:size-6 p-2')

    Icon ??= <HelpCircleIcon />

    const [open, setOpen] = React.useState(false)

    function handleOpenChange() {
        setTimeout(() => {
            setOpen(!open)
        }, 150)
    }

    return (
        <Popover open={open} onOpenChange={handleOpenChange}>
            <PopoverTrigger asChild>
                <PopoverAnchor
                    className={cn({
                        'group-aria-disabled:pointer-events-none':
                            !forceEnabled,
                    })}
                >
                    <ButtonBase
                        variant="ghost"
                        size="icon"
                        className={cn(
                            sizeClass,
                            'rounded-full text-foreground hover:text-foreground size-fit',
                            className,
                        )}
                    >
                        {Icon}
                    </ButtonBase>
                </PopoverAnchor>
            </PopoverTrigger>

            <PopoverContent
                className={cn('text-left', {
                    'p-0 border-0': borderless,
                })}
            >
                {children}
            </PopoverContent>
        </Popover>
    )
}
